import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Form } from '$common';
import CSSModules from 'react-css-modules';
import style from './autocomplete.scss';

@CSSModules(style)
export default class AutoComplete extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    getFormValue: PropTypes.func
  };

  state = {
    placeholder: ''
  }

  handleInputChange(e) {
    const value = e.target.value;
    this.setState({ placeholder: value });

    if (value.length > 2) {
      if (this.timeoutId) clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.props.searchEndpoint(value).then(({data: suggestions}) => {
          this.setState({ suggestions });
        });
      }, 500);
    } else {
      this.setState({ suggestions: null })
    }
  }

  handleChange(id) {
    if (this.context.onChange) {
      this.context.onChange(this.name, id)
    }

    if (this.props.onChange) {
      this.props.onChange(id);
    }
  }

  handleSelection(suggestion) {
    return async () => {
      this.setState({ suggestions: null, placeholder: suggestion.name, suggestionId: suggestion.id });
      this.handleChange(suggestion.id);
    }
  }

  componentWillMount() {
    this.setState({ suggestionId: null })
  }

  get name() {
    return this.props.name || this.context.formFieldName;
  }

  render() {
    const { suggestions, placeholder, suggestionId } = this.state;
    const { size } = this.props;

    const suggestionList = suggestions && suggestions.map(item => (
      <li onClick={::this.handleSelection(item)} key={item.id}>
        { item.name }
      </li>
    ));

    return (
      <div styleName="root" style={{ position: 'relative' }}>
        <input
          name="$$suggestion"
          size={size}
          styleName="input"
          value={placeholder}
          onChange={::this.handleInputChange}
          placeholder={this.props.placeholder}
        />
        {suggestions ? (
          <ul styleName="suggestion-list">
            {suggestionList}
          </ul>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/autocomplete.js